export const Messages = {
  error: {
    E001: 'URL not valid',
    E002: 'Invalid Parameters',
    E003: 'Body not provided!',
    E004: 'Something went wrong',
    E005: 'Request already in process',
    E006: 'Bad Request',
    E007: 'Request Timeout',
  },
  info: {
    I001: 'API Cache initialized!!',
    I002: 'Cached API requests:',
  },
  labels: {
    L001: 'API Res',
    L002: 'Response With Error',
  },
};

/**
 * Replaces placeholders in a label with provided parameters.
 *
 * @param {string} label - The label containing placeholders to be replaced, e.g., 'URL not valid ${0} ${1}'.
 * @param {...string[])} params - Multiple parameters to replace placeholders (${0}, ${1}, etc.).
 *   Boolean, Number, Array or object parameters should be passed as strings (stringify).
 * @returns {string} - The formatted label with replaced placeholders.
 *
 * @example
 * const formattedLabel = parameterizedLabel('URL not valid ${0} ${1}', 'param1', 'param2');
 * // Result: 'URL not valid param1 param2'
 *
 * @example
 * const complexParams = [{ key: 'value' }, true, 42];
 * const formattedLabel = parameterizedLabel('Complex label ${0} ${1} ${2}', JSON.stringify(complexParams), 'boolValue', 'numberValue');
 * // Result: 'Complex label {"key":"value"} true 42'
 */
export const parameterizedLabel = (label: string, ...params: string[]): string => {
  const placeholderRegex = /\${(\w+)}/g;
  const formattedLabel = label.replace(placeholderRegex, (_match, index) => {
    const i = parseInt(index, 10);
    return !isNaN(i) && i < params.length ? params[i] : '';
  });

  return formattedLabel.trim();
};
